/**
 * Batch Report (PO Report) Excel export — tải multi-sheet .xlsx do BE generate
 * (`GET /factories/{fc}/batch-report/{po}/export`). Auth qua Bearer token (cùng
 * key `token` với apiSlice). Filename ưu tiên Content-Disposition của server.
 */
import { API_BASE_URL } from '@/config/api'
import { getStoredToken } from '@/services/auth'

function extractFilename(disposition: string | null, fallback: string): string {
  if (!disposition) return fallback
  // Ưu tiên `filename*=UTF-8''…` — server (Starlette) CHỈ phát dạng này khi tên file
  // có space/dấu tiếng Việt (vd "PRO… - BTA1 - Đắk Lắk.xlsx"), không kèm `filename="…"`.
  const star = /filename\*\s*=\s*([^;]+)/i.exec(disposition)
  if (star?.[1]) {
    const v = star[1].trim().replace(/^UTF-8''/i, '').replace(/^"|"$/g, '')
    try {
      return decodeURIComponent(v)
    } catch {
      return v
    }
  }
  const match = /filename="?([^";]+)"?/i.exec(disposition)
  return match?.[1] || fallback
}

function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

export async function downloadBatchReportExport(
  factoryCode: string,
  poNo: string,
  comparisonPoNo?: string,
): Promise<void> {
  const po = poNo.trim()
  const cmp = comparisonPoNo?.trim()
  const qs = cmp ? `?comparison_po_no=${encodeURIComponent(cmp)}` : ''
  const endpoint = `${API_BASE_URL}/factories/${factoryCode}/batch-report/${encodeURIComponent(po)}/export${qs}`
  const token = getStoredToken()
  const res = await fetch(endpoint, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })
  if (!res.ok) {
    throw new Error(`Export failed (${res.status})`)
  }
  const blob = await res.blob()
  const fallback = `batch-report_${factoryCode}_${po}.xlsx`
  downloadBlob(blob, extractFilename(res.headers.get('Content-Disposition'), fallback))
}
